import { render, staticRenderFns } from "./CartPickup.vue?vue&type=template&id=504bba1c"
import script from "./CartPickup.vue?vue&type=script&lang=js"
export * from "./CartPickup.vue?vue&type=script&lang=js"
import style0 from "./CartPickup.vue?vue&type=style&index=0&id=504bba1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports